<template>
  <card>
    <list
      v-if="$store.state.user.sections['trade_ins']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setImport="false"
      :setLink="setLink"
      :staticFilters="staticFilters"
      :openItem="true"
      :fields="fields"
      :filters="filters"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
      :dateFilter="dateFilter"
      :projectInfo="4"
    />
    <h4 v-else>{{ "no_acccess" | setText("НЕТ ДОСТУПА") }}</h4>
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },

  created() {
    if (this.$store.state.user.is_root) {
      this.filters.push({
        key: "shop",
        title: "Фильтр по торговым точкам",
        titleKey: "shop_filter",
        field_key: "shop",
        selectKey: "name",
      });
    }
  },
  data() {
    return {
      filters: [
        {
          key: "user",
          title: "Фильтр по сотрудникам",
          titleKey: "user_filter",
          field_key: "user",
          selectKey: "name",
        },
      ],
      staticFilters: [
        {
          title: "Статус",
          key: "status_transfer",
          default: "0",
          items: [
            {
              id: "0",
              title: "Показать все",
            },
            {
              id: "new",
              title: "В процессе",
            },
            {
              id: "process",
              title: "Упакован в сейф-пакет",
            },
            {
              id: "sent",
              title: "Отправлен на склад",
            },

            {
              id: "received",
              title: "Прибыл на склад",
            },
            {
              id: "done",
              title: "Отправлен со склада",
            },
            {
              id: "cancel",
              title: "Отменен",
            },
          ],
        },
      ],
      params: {},
      val: [],
      modalCreate: "role",
      fields: [
        {
          col: "col-12 col-md-6",
          label: "Номер телефона покупателя",
          key: "phone",
          labelKey: "phone",
          type: "mask",
          mask: "+998#########",
          default: "+998",
        },
        {
          col: "col-12 col-md-6",
          label: "Имя",
          key: "first_name",
          type: "field",
        },
        {
          col: "col-12 col-md-6",
          label: "Фамилия",
          key: "last_name",
          type: "field",
        },
        {
          col: "col-12 col-md-6",
          label: "Отчество",
          key: "family_name",
          type: "field",
        },
        {
          col: "col-12 col-md-6",
          label: "Фото передней стороны устройства (хорошее качество)",
          key: "photo_device_front",
          type: "img",
        },
        {
          col: "col-12 col-md-6",
          label: "Фото задней стороны устройства (хорошее качество)",
          key: "photo_device_back",
          type: "img",
        },
        {
          col: "col-12 col-md-6",
          label: "Фото боковой стороны устройства (хорошее качество)",
          key: "photo_device_side",
          type: "img",
        },
      ],
      dateFilter: [
        {
          key: "from_at",
          titleKey: "from_at",
          title: "Начало даты",
        },
        {
          key: "till_at",
          titleKey: "till_at",
          title: "Конец даты",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_trade_in",
      itemLink: "trade_ins",
      setLink: "trade_ins",
      columns: [
        {
          detail: true,
        },
        {
          key: "id",
          title: "ID",
        },
        {
          key: "code",
          title: "Сейф-пакет",
        },
        {
          key: "photo_document_sign",
          title: "Договор",
          checkbox: false,
          control: false,
          link: true,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "shop",
          object: "name",
          title: "Торговая точка",
          disableLink: true,
          full: true,
        },
        {
          key: "first_name",
          title: "Имя",
          full: true,
        },
        {
          key: "last_name",
          title: "Фамилия",
          full: true,
        },
        {
          key: "display_status_transfer",
          title: "Статус",
          full: true,
        },
        {
          key: "user",
          object: "name",
          title: "Оператор",
          disableLink: true,
          full: true,
        },
        {
          key: "user",
          object: "phone",
          title: "Номер оператора",
          disableLink: true,
          full: true,
        },
        {
          key: "client",
          object: "phone",
          title: "Номер телефона",
          full: true,
          disableLink: true,
        },
        {
          key: "name",
          title: "Название смартфона",
          full: true,
        },
        {
          key: "imei",
          title: "IMEI 1",
          full: true,
        },
        {
          key: "price",
          title: "Оценка",
          price: true,
          full: true,
        },
        {
          key: "created_at",
          title: "Дата создания",
          dateTimeFormat: true,
          full: true,
        },
      ],
    };
  },
};
</script>